import React, { Component, useState } from 'react';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import { Doughnut } from 'react-chartjs-2';
import { useEffect } from 'react';
import './DonutSubmission.css';
import { useTranslation } from 'react-i18next';


ChartJS.register(ArcElement, Tooltip, Legend);


const DonutSubmission = (props) => {


    useEffect(() => {
        populateSubmissionData();
    }, [props.searchButtonPressed]);


    const [submissionCountData, setSubmissionCountData] = useState([])
    const [isLoading, setIsLoading] = useState(false);
    const { t } = useTranslation();

    async function populateSubmissionData() {
        setIsLoading(true);
        const encodedType = encodeURIComponent(props.type ? props.type : "grabber");
        const encodedPhoneNo = encodeURIComponent(props.phoneNo ? props.phoneNo : "A");
        const encodedCarPlate = encodeURIComponent(props.carPlate ? props.carPlate : "A");
        const encodedEmail = encodeURIComponent(props.email ? props.email : "A");

        const response = await fetch(`form/submissionCount?type=${encodedType}&email=${encodedEmail}&phoneNo=${encodedPhoneNo}&carPlate=${encodedCarPlate}`);
        const data = await response.json();
        setSubmissionCountData(data);
        setIsLoading(false);
    }

    const data = {
        labels: [t('Dashboard.Label.Approved'), t('Dashboard.Label.Rejected'), t('Dashboard.Label.Pending')],
        datasets: [
            {
                label: 'Submission',
                data: [submissionCountData.approved, submissionCountData.rejected, submissionCountData.pending],
                backgroundColor: [
                    
                    
                    'rgb(10,152,48)',
                    'rgb(180,100,56)',
                    'rgb(149,154,157)',
                ],
                borderColor: [                                        
                    'rgb(10,152,48)',
                    'rgb(180,100,56)',
                    'rgb(149,154,157)',
                ],
                borderWidth: 1,
            },
        ],
    };

    const options =  {
        plugins: {
            datalabels: {
                formatter: (value) => {
                    return value + '%';
                },
      },
        },
    }

    const plugins = [{
        beforeDraw: function (chart) {
            var width = chart.width,
                height = chart.height,
                ctx = chart.ctx;
            ctx.restore();
            var fontSize = (height / 250).toFixed(2);
            ctx.font = "bold " + fontSize + "em sans-serif";
            //Font-Color
            ctx.fillStyle = "#616161"
            ctx.textBaseline = "top";
            var text = "TOTAL",
                textX = Math.round((width - ctx.measureText(text).width) / 2),
                textY = height / 2.3;
            ctx.fillText(text, textX, textY);
            var text = "RM " +  submissionCountData.approved * 4 ,
                textX = Math.round((width - ctx.measureText(text).width) / 2),
                textY = height / 1.8;
            ctx.fillText(text, textX, textY);
            ctx.save();
        }
    }]


    return (
        <div className = "div-submission">
            <label className="label-submission" >{t('Dashboard.Label.Submission')}</label>
            <br />
            {submissionCountData.approved !== ''&& !isLoading ? (
                <Doughnut data={data} plugins={plugins} options={options} />
            ) : (
                <img src="https://spagblob.blob.core.windows.net/odin-image/Loading.gif"  alt="loading" />
            )}          
        </div>
    );

}

export default DonutSubmission;
